import { Record } from 'immutable';

const BankAccountBalanceMetricRecord = Record({
  min: 0,
  max: 0,
  opening: 0,
  closing: 0,
  average: 0,
});

export default class BankAccountBalanceMetric extends BankAccountBalanceMetricRecord {
  static deserialize(jsonObject = {}) {
    return new BankAccountBalanceMetric(jsonObject);
  }
}
